module.exports = __webpack_public_path__ + "images/emoji/dog.92aa2e008f2c6c895f39.png";